// extracted by mini-css-extract-plugin
module.exports = {"inner":"DeclineReason_inner__bGii6","inputContainer":"DeclineReason_inputContainer__2r8DB","inputLoader":"DeclineReason_inputLoader__ELGKj"};